<template>
    <div
        :class="[
            `
              bg-black/15 size-[48px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full flex items-center justify-center
              transition-opacity duration-500 pointer-events-none
            `,
            { 'opacity-0': !isVisible, 'opacity-100': isVisible }
        ]"
    >
        <touch-app-icon class="size-[32px] text-white" />
    </div>
</template>

<script>
    import TouchAppIcon from '../icons/TouchAppIcon.vue';

    export default {
        components: {
            TouchAppIcon,
        },

        data() {
            return {
                isVisible: false,
            };
        },

        mounted() {
            this.isVisible = true;
            setTimeout(() => {
                this.isVisible = false;
            }, 6000);
        },
    };
</script>
